export const checkIfJobTilesHaveProfile = () => {
    const jobsWidget = document.querySelectorAll(".jobs-carousel");

    if (!jobsWidget) return;

    jobsWidget.forEach((widget) => {
        const hasProfile = widget.querySelector(
            ".attrax-vacancy-tile__author-image-link"
        );

        if (hasProfile) {
            widget.classList.add("has-profile");
        }
    });
};


export const setTabHeadingToID = () => {
     const tabHeadings = document.querySelectorAll<HTMLParagraphElement>(".attrax-list-widget__tab-heading");

     tabHeadings.forEach((tabHeading) => {
        if (tabHeading.textContent) {
            tabHeading.id = tabHeading.textContent.toLowerCase().replace(/\s+/g, '-');
        }
     })
}